import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, Optional, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ITdoTreeItem } from '../../../tdo-controls/common/tdo-tree/models/i-tdo-tree-item';
import { IoTreeNodeModel } from '../../../modules/imaging/models/io-tree-node.model';
import {
  Constants,
  DOC_FOLDER_ROOT_LECTURE,
  DOC_FOLDER_ROOT_LIBRARY,
  DOC_FOLDER_ROOT_PATIENT,
  IO_TREE_CASES_NODE_ID,
  IO_TREE_CATS_NODE_ID,
  IO_TREE_CURR_PATIENT_NODE_ID,
  IO_TREE_EXAM_NODE_ID,
  IO_TREE_IMPORT_NODE_ID,
  IO_TREE_NO_CAT_NODE_ID
} from '../../../constants';
import { IoTreeNodeTypeModel } from '../../../modules/imaging/models/io-tree-node-type.model';
import { FileManagerService } from '../../../modules/file-manager/file-manager.service';
import { Globals } from '../../../globals';
import { enumSortBy } from '../../../modules/imaging/image-organizer/io-toolbar/io-toolbar.component';
import { DocumentDataModel } from '../../../models/document/document-data.model';
import { TdoDropdownModel } from '../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import { TdoOrganizerStaticDataset } from './models/tdo-organizer-static.dataset';
import { DocumentDataImageModel } from './models/document-data-image.model';
import { ITdoImageGridItem } from '../../../tdo-controls/common/tdo-image-grid/models/i-tdo-image-grid-item';
import { CdkDragDrop, CdkDragEnter, CdkDragExit, moveItemInArray } from '@angular/cdk/drag-drop';
import { ReorderEventData } from '../../../modules/imaging/image-organizer/views/io-view-thumbnail/io-view-thumbnail.component';
import { TdoImageGridComponent } from '../../../tdo-controls/common/tdo-image-grid/tdo-image-grid.component';
import moment from 'moment';
import { OrganizerContextMenuComponent } from '../../organizer/organizer-context-menu/organizer-context-menu.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TdoOrganizerFilterComponent } from '../../organizer/dialogs/tdo-organizer-filter/tdo-organizer-filter.component';
import { SchedulingService } from '../../../modules/scheduling/scheduling.service';
import { DoctorScheduleModel } from '../../../models/doctors/doctor-schedule.model';
import { TdoOrganizerFilterDataModel } from '../../organizer/dialogs/tdo-organizer-filter/models/tdo-organizer-filter-data.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { StaticDataService } from '../../../services/static-data.service';
import { TdoOrganizerFilterResultModel } from '../../organizer/dialogs/tdo-organizer-filter/models/tdo-organizer-filter-result.model';
import { OrganizerFilterDateRangeHandler } from './models/organizer-filter-date-range.handler';
import { TdoImageGridContextModel } from '../../../tdo-controls/common/tdo-image-grid/models/tdo-image-grid-context.model';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { fromEvent, Subscription } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TdoOrganizerCategorizeDialogComponent } from '../../organizer/dialogs/tdo-organizer-categorize-dialog/tdo-organizer-categorize-dialog.component';
import { TdoOrganizerCategorizeModel } from '../../organizer/dialogs/tdo-organizer-categorize-dialog/models/tdo-organizer-categorize.model';
import { DocumentFolderDataModel } from '../../../models/document/document-folder-data.model';
import { TdoOrganizerRenameDialogComponent } from '../../organizer/dialogs/tdo-organizer-rename.dialog/tdo-organizer-rename-dialog.component';
import { DocumentFolderTypeEnum } from '../../../models/enum/document/document-folder-type.enum';
import { Clipboard } from '@angular/cdk/clipboard';
import { TdoClipboardBaseModel } from '../../../models/clipboard/tdo-clipboard-base.model';
import { DocumentsPerFolderModel } from '../../../models/document/documents-per-folder.model';
import { DocumentUpdateFolderModel } from '../../../models/document/document-update-folder.model';
import { TdoOrganizerSlideshowDialogComponent } from '../../organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';
import { FileHelperService } from '../../../services/file-helper.service';
import { DocumentUploadModel } from '../../../models/document/document-upload.model';
import { DocumentClassEnum } from '../../../models/enum/document/document-class.enum';
import { DocumentFileTypeEnum } from '../../../models/enum/document/document-file-type.enum';
import { DocumentTypeEnum } from '../../../models/enum/document/document-type.enum';
import { DialogService } from '../../../services/dialog.service';
import { GetDocumentThumbnailModel } from './models/get-document-thumbnail.model';
import { MessagingService } from '../../../services/messaging.service';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { SignalrService } from '../../../services/socket/signalr.service';
import { UiService } from '../../../services/ui.service';
import { DocumentRestoreFolderModel, DocumentRestoreModel } from '../../../models/document/document-restore.model';
import { TdoOrganizerRestoreDialogComponent } from '../../organizer/dialogs/tdo-organizer-restore.dialog/tdo-organizer-restore.dialog.component';
import { DocumentInFolderDataModel } from '../../../models/document/document-in-folder-data.model';
import { TdoTreeDropItem } from '../../../tdo-controls/common/tdo-tree/tdo-tree.component';
import { DocumentTagDataModel } from '../../../models/document/document-tag-data.model';
import { OrganizerOpenInImagingModel } from './models/organizer-open-in-imaging.model';
import { TdoOrganizerCaseToothDialogComponent } from '../../organizer/dialogs/tdo-organizer-case-tooth-dialog/tdo-organizer-case-tooth-dialog.component';
import { LabelService } from '../../../services/label.service';
import { LabelRequestModel } from '../../../models/labels/label-request.model';
import { FormattedLabelEnum } from '../../../models/enum/labels/formatted-label.enum';
import { LabelResponseModel } from '../../../models/labels/label-response.model';
import { AuthenticationService } from '../../../modules/auth/services/authentication.service';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { ImageUtilities } from '../../../utilities/image.utilities';
import { TdoImagingService } from '../../imaging/tdo-imaging.service';
import {
  PresentationFoldersConfigurationService
} from '../../../modules/configuration/ui/presentation-folders-configuration/presentation-folders-configuration.service';
import { DatePipe } from '@angular/common';
import { RightClickData } from 'src/app/models/ui/rightclickdata';
import { TdoNoteQueryModel } from '../tdo-notes/models/tdo-note-query.model';
import { NoteCategoryEnum } from 'src/app/models/enum/note-category.enum';
import { NotesService } from 'src/app/services/notes.service';
import { TDOPrintService } from 'src/app/services/print/tdoprint.service';

const DOC_CLASS_ORIGINAL = '00000075-1000-0000-0000-000000000001';
declare const openSaveAs: any;
declare const openFolderToSaveTo: any;

@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'tdo-organizer',
  templateUrl: './tdo-organizer.component.html',
  styleUrls: ['./tdo-organizer.component.scss']
})
export class TdoOrganizerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tdoImageGrid') imageGrid: TdoImageGridComponent;
  @ViewChild('organizerContext') organizerContextMenu: OrganizerContextMenuComponent;
  @ViewChild('gridContainer') gridContainer: ElementRef;

  @ViewChild('imageContextTemplate') imageContextTemplate: TemplateRef<any>;
  @ViewChild('lectureContextMenu') lectureContextTemplate: TemplateRef<any>;
  @ViewChild('patientContextMenu') patientContextTemplate: TemplateRef<any>;
  @ViewChild('folderBackgroundContextMenu') folderBackgroundContextMenu: TemplateRef<any>;
  @ViewChild('emptyAreaContextMenu') emptyAreaContextMenu: TemplateRef<any>;

  staticDataSet = new TdoOrganizerStaticDataset();
  labelResponseModels: LabelResponseModel[] = [];

  patientTreeData: IoTreeNodeModel[] = [];
  selectedPatientTreeNode: IoTreeNodeModel;

  libraryTreeData: IoTreeNodeModel[] = [];
  lectureTreeData: IoTreeNodeModel[] = [];

  folderPresentationTreeData: IoTreeNodeModel[] = [];

  thumbnailImages: DocumentDataImageModel[];
  images: DocumentInFolderDataModel[] = [];
  numImages: number = 0;
  selectedImages: DocumentInFolderDataModel[] = [];
  numSelectedImages: number = 0;

  private _colorWorker: Worker | null = null;
  private _effectsWorker: Worker | null = null;

  tooltipsResponseModels: LabelResponseModel[] = [];

  isImagesLoading = false;
  isShowPublish = false;
  isAscending = false;
  thumbnailImageSize = 150;
  selectedTab = 0;

  viewType = 'thumbnail'; // detail, gallery, pane, thumbnail
  sortType = 'user_defined';

  selectedCollageID: string = '';
  currentLOCID: string;
  doctors: DoctorScheduleModel[];
  referringDoctors: DoctorScheduleModel[];

  dateRangeDropDownData: TdoDropdownModel[];
  doctorsDropdownData: TdoDropdownModel[];
  referringDoctorsDropdownData: TdoDropdownModel[];
  documentTagOptions: EnumValidValueItemModel[];

  isFavoritesSubmenuOpen = false;
  favoriteCategorizeTags: EnumValidValueItemModel[] = [];
  selectedFavoriteCategorizeTags: EnumValidValueItemModel[] = [];

  filterStaticData = new TdoOrganizerFilterDataModel();
  filterModel: TdoOrganizerFilterResultModel = new TdoOrganizerFilterResultModel();
  filterDateRangeEnums: EnumValidValueItemModel[];

  filetypes = 'image/png, image/jpeg, video/quicktime, video/avi, video/mp4, audio/mpeg, audio/wav, application/pdf,' +
    ' application/json, application/xml,' +
    ' application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
    ' application/vnd.openxmlformats-officedocument.presentationml.presentation,' +
    ' application/vnd.ms-excel, application/vnd.ms-powerpoint,' +
    ' application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  returnDocumentIDMode: boolean = false;

  private refreshDebounceTimer: number | null = null;
  private selectedSortMode: enumSortBy = enumSortBy.DateCreated;
  private dateRangeHandler: OrganizerFilterDateRangeHandler;

  private overlayRef: OverlayRef | null;
  private sub: Subscription;
  private subscriptions: Subscription[] = [];
  public isPickList: boolean = false;
  public operationMode: string;
  public folderToBrowse: string;
  public hidePatientTab: boolean = false;
  public hideLibraryTab: boolean = false;
  public hideLectureTab: boolean = false;
  public hideFolderPresentationTab: boolean = false;

  constructor(private readonly fileService: FileManagerService,
    private readonly authService: AuthenticationService,
    private readonly messagingService: MessagingService,
    private readonly globals: Globals,
    private readonly dialog: MatDialog,
    private readonly labelService: LabelService,
    private readonly scheduleService: SchedulingService,
    public fileManagerService: FileManagerService,
    private readonly staticDataService: StaticDataService,
    private readonly overlay: Overlay,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly snackbar: MatSnackBar,
    private readonly clipboard: Clipboard,
    private readonly dialogService: DialogService,
    private readonly signalrService: SignalrService,
    private readonly uiService: UiService,
    private readonly fileHelperService: FileHelperService,
    private readonly drawService: TdoImagingService,
    private readonly dialogRef: MatDialogRef<TdoOrganizerComponent>,
    public datePipe: DatePipe,
    private readonly notesService: NotesService,
    private readonly printService: TDOPrintService,
    private readonly cdr: ChangeDetectorRef,
    private readonly ngZone: NgZone,
    @Optional() @Inject(MAT_DIALOG_DATA) data) {
    this.currentLOCID = localStorage.getItem('LOCID');
    if (data !== null) {
      this.isPickList = data.PickList;
      this.operationMode = data.OperationMode;
      this.folderToBrowse = data.FolderToBrowse;
      this.selectedTab = 0;

      if (data.HidePatientTab !== undefined) {
        this.hidePatientTab = data.HidePatientTab;
      }
      if (data.HideLectureTab !== undefined) {
        this.hideLectureTab = data.HideLectureTab;
      }
      if (data.ReturnDocumentIDMode !== undefined) {
        this.returnDocumentIDMode = data.ReturnDocumentIDMode;
      }
    }
  }

  private scheduleOrganizerRefresh(): void {
    if (this.refreshDebounceTimer !== null) {
      clearTimeout(this.refreshDebounceTimer);
    }
    this.refreshDebounceTimer = window.setTimeout(() => {
      this.refreshDebounceTimer = null;
      this.getThumbnails(this.selectedPatientTreeNode);
      if (this.selectedPatientTreeNode?.isPatientTree) {
        this.fillPatientFolderTree();
      }
    }, 300);
  }

  private readonly onCrossWindowStorageRefresh = (e: StorageEvent): void => {
    if (e.key !== MessagingConstants.LOCAL_STORAGE_PATIENT_PICTURE_REFRESH || !e.newValue) return;
    try {
      const data = JSON.parse(e.newValue) as { patientId?: string };
      if (data.patientId && data.patientId === this.globals.currentPatientId) {
        this.ngZone.run(() => this.scheduleOrganizerRefresh());
      }
    } catch { /* ignore */ }
  };

  ngOnInit(): void {
    this._colorWorker = new Worker('assets/leadtools/Leadtools.ImageProcessing.Color.js');
    this._effectsWorker = new Worker('assets/leadtools/Leadtools.ImageProcessing.Effects.js');

    window.addEventListener('storage', this.onCrossWindowStorageRefresh);

    const signalrSub = this.signalrService.messageUser.subscribe((sockRes) => {
      // console.log('mtm organizer SignalrService.messageUser sockRes ', sockRes);
      switch (sockRes.messageType) {
        case SignalrService.UPDATE_DOCUMENT:
          // console.log('mtm organizer SignalrService.UPDATE_DOCUMENT pt id ', this.globals.currentPatientId);
          // console.log('mtm organizer SignalrService.UPDATE_DOCUMENT sockRes ', sockRes.message['patientId']);
          if (sockRes.message['patientId'] === this.globals.currentPatientId) {
            // console.log('mtm organizer SignalrService.UPDATE_DOCUMENT pt id matached ');
            this.getThumbnails(this.selectedPatientTreeNode);
            if (this.selectedPatientTreeNode.isPatientTree) {
              this.fillPatientFolderTree();
            }
          }
          break;
        case SignalrService.REFRESH_FOLDERS:
          this.libraryTreeData = [];
          this.lectureTreeData = [];
          this.folderPresentationTreeData = [];
          this.initializePatientFolderTree();
          this.init();
          break;
        case 'brokerImageData':
          try {
            const obj = JSON.parse(sockRes.message as unknown as string);
            // Only refresh after the backend upload is confirmed complete (type: document-saved).
            // The early UploadToBrowserAsync broadcast fires before the file reaches the backend,
            // so reacting to it would fetch thumbnails before the new document exists.
            if (obj?.type === 'document-saved') {
              this.scheduleOrganizerRefresh();
            }
          } catch { /* ignore malformed messages */ }
          break;
      }
    });
    this.subscriptions.push(signalrSub);


    this.messagingService.sendComponentMessage(MessagingConstants.CASE_VIEW_COLLAPSE, null);

    const compMessageSub = this.messagingService.componentMessageCall.subscribe((data) => {
      switch (data.event) {
        case MessagingConstants.PATIENT_LOADED:
          // console.log('mtm organizer MessagingConstants.PATIENT_LOADED');
          // this.getThumbnails();
          // this.initializePatientFolderTree();
          // this.init();
          break;
      }
    });

    this.subscriptions.push(compMessageSub);
    this.initializePatientFolderTree();
    this.init();

    this.fileManagerService.getDocumentTagOptions().subscribe((data) => {
      this.documentTagOptions = data;
      this.filterStaticData.documentTagOptions = data;
    });

    this.dateRangeHandler = new OrganizerFilterDateRangeHandler(this.staticDataService);

    const noteQueryModel = new TdoNoteQueryModel();
    noteQueryModel.parentObjectName = 'PatientId';
    noteQueryModel.objectId = this.globals.currentPatientId;
    noteQueryModel.patientId = this.globals.currentPatientId;
    noteQueryModel.categoryEnumId = NoteCategoryEnum.Document;

    this.notesService.changeNoteQuery(noteQueryModel);

  }

  ngAfterViewInit() {
    // console.log('ngAfterViewInit this.operationMode', this.operationMode);
    if (this.operationMode === 'FolderPresentation') {
      this.hideLectureTab = true;
      this.hidePatientTab = true;
      this.hideLibraryTab = true;
      this.fileManagerService.getLibraryDocumentFoldersPresentation(this.folderToBrowse).subscribe((res) => {
        this.initFolderPresentationTree(res);
        this.selectedPatientTreeNode = this.folderPresentationTreeData[0];
        this.onPatientTreeItemSelected(this.selectedPatientTreeNode);
        this.cdr.detectChanges();
      });
    }
    else {
      this.getThumbnails();
    }
  }

  openFilters() {
    const config = new MatDialogConfig();
    config.panelClass = 'standard-dialog';
    if (this.filterModel) {
      this.filterStaticData.filterModel = this.filterModel;
    }
    if (!this.dateRangeDropDownData) {
      this.dateRangeDropDownData = this.dateRangeHandler.items.map(p => new TdoDropdownModel(p.ItemDisplayValue, p));
    }
    this.filterStaticData.dateRangeDropDownData = this.dateRangeDropDownData;
    config.data = this.filterStaticData;
    this.dialog.open(TdoOrganizerFilterComponent, config).afterClosed().subscribe((result) => {
      if (result) {
        this.filterModel = result;
        if (!this.isFilterActive() || this.filterModel.isWasNotApplied) {
          return;
        }
        this.isImagesLoading = true;
        // TODO: Change call to returne DocumentInFolderDataModel
        this.fileManagerService.getDocumentsByFilter(result).subscribe((data) => {
          // this.images = data;
          this.isImagesLoading = false;
          this.mapThumbnails();
        });
      }
    });
  }

  private async init() {
    if (this.operationMode !== 'FolderPresentation') {
      this.fileManagerService.getLibraryDocumentFolders().subscribe((res) => {
        this.initLibraryTree(res.LibraryFolders);
        this.initLectureTree(res.LectureFolders);
        this.cdr.detectChanges();
      });

      await this.fillPatientFolderTree();
    }
  }


  private async fillPatientFolderTree(): Promise<void> {
    try {
      const patientTagList = await this.fileManagerService.getPatientTagList({
        PatientID: this.globals.currentPatientId,
        PatientCaseID: '',
        WorkItemEventID: ''
      }).toPromise();

      const categoryNodes: IoTreeNodeModel[] = patientTagList.patient.map(o => {
        const model = new IoTreeNodeModel();
        model.id = o.id;
        model.name = o.name;
        model.documents = [];
        model.type = IoTreeNodeTypeModel.Category;
        model.parent = null;
        model.isExpanded = false;
        model.editMode = false;
        model.isPatientTree = true;

        model.children = o.patientTeeth.map(p => {
          const m1 = new IoTreeNodeModel();
          m1.id = p.toothId;
          m1.name = p.name;
          m1.parent = model;
          m1.type = IoTreeNodeTypeModel.Teeth;
          m1.children = p.caseItems.map(q => {
            const q1 = new IoTreeNodeModel();
            q1.name = q.name;
            q1.id = q.id;
            q1.type = IoTreeNodeTypeModel.Case;
            q1.parent = m1;
            return q1;
          });

          return m1;
        });
        return model;
      });

      const caseNodes: IoTreeNodeModel[] = patientTagList.cases.map(o => {
        const model = new IoTreeNodeModel();
        model.id = o.id;
        model.name = o.name + ' ' + this.datePipe.transform(o.xauditCreatedOn, 'MMM dd, yyyy');
        model.isPatientTree = true;
        model.type = IoTreeNodeTypeModel.Case;
        model.isExpanded = false;

        model.children = o.caseTeeth.map(p => {
          const m2 = new IoTreeNodeModel();
          model.name = o.name + ' ' + p.name.replace('Tooth #', '#') + ' ' + this.datePipe.transform(o.xauditCreatedOn, 'MMM dd, yyyy');
          m2.isPatientTree = true;
          m2.type = IoTreeNodeTypeModel.Teeth;
          m2.id = p.id;
          m2.name = p.name;
          m2.parent = model;

          m2.children = p.caseTags.map(q => {
            const m3 = new IoTreeNodeModel();
            m3.isPatientTree = true;
            m3.type = IoTreeNodeTypeModel.Category;
            m3.id = q.id;
            m3.name = q.name;
            m3.parent = m2;
            return m3;
          });
          return m2;
        });

        return model;
      });

      const patientModel = this.patientTreeData.find(p => p.name === 'Current Patient');
      if (patientModel) {
        const categoryModel = patientModel.children.find(p => p.name === 'Categories');
        if (categoryModel) {
          categoryModel.isExpanded = false;
          categoryModel.children = [];
          categoryModel.children = categoryNodes;
        }
        const caseModel = patientModel.children.find(p => p.name === 'Cases/Teeth');
        caseModel.isExpanded = false;
        caseModel.children = [];
        caseModel.children = caseNodes;
      }
    }
    catch {
      throw new Error('Something went wrong while trying to load IO patient tab');
    }
  }

  private initializePatientFolderTree(): void {

    const currentPatientNode: IoTreeNodeModel =
    {
      id: IO_TREE_CURR_PATIENT_NODE_ID,
      name: 'Current Patient',
      children: [],
      documents: [],
      type: IoTreeNodeTypeModel.Default,
      parent: null,
      isExpanded: true,
      editMode: false,
      isPatientTree: true,
      matIconOverride: null
    };
    this.selectedPatientTreeNode = currentPatientNode;

    currentPatientNode.children = [
      {
        id: IO_TREE_CATS_NODE_ID,
        name: 'Trash',
        children: [],
        documents: [],
        type: IoTreeNodeTypeModel.Trash_Patient,
        // parent: currentPatientNode,
        isExpanded: false,
        editMode: false,
        isPatientTree: true,
        matIconOverride: 'delete'
      },
      {
        id: IO_TREE_CATS_NODE_ID,
        name: 'Categories',
        children: [],
        documents: [],
        type: IoTreeNodeTypeModel.Category,
        // parent: currentPatientNode,
        isExpanded: false,
        editMode: false,
        isPatientTree: true,
        matIconOverride: null
      },
      {
        id: IO_TREE_CASES_NODE_ID,
        name: 'Cases/Teeth',
        children: [],
        documents: [],
        type: IoTreeNodeTypeModel.Case,
        // parent: currentPatientNode,
        isExpanded: false,
        editMode: false,
        isPatientTree: true,
        matIconOverride: null
      },
      {
        id: IO_TREE_EXAM_NODE_ID,
        name: 'Exam/Event/Appointment',
        children: [],
        documents: [],
        type: IoTreeNodeTypeModel.Default,
        // parent: currentPatientNode,
        isExpanded: false,
        editMode: false,
        isPatientTree: true,
        matIconOverride: null
      }
    ];

    this.patientTreeData = [
      {
        id: IO_TREE_IMPORT_NODE_ID,
        name: 'Imports',
        children: [],
        documents: [],
        type: IoTreeNodeTypeModel.Default,
        parent: null,
        isExpanded: false,
        editMode: false,
        isPatientTree: true,
        matIconOverride: null
      },
      currentPatientNode
    ];
  }

  onPatientTreeItemSelected(item: ITdoTreeItem) {
    // console.log('onPatientTreeItemSelected', item);
    if (this.operationMode !== 'FolderPresentation') {
      if (this.selectedPatientTreeNode === item) {
        return;
      }
    }
    this.selectedPatientTreeNode = item as IoTreeNodeModel;


    switch (item.name) {
      case 'Categories':
      case 'Cases/Teeth':
      case 'Exam/Event/Appointment':
        this.getThumbnails();
        break;
      default:
        this.getThumbnails(item as IoTreeNodeModel);
        break;
    }
  }

  onFolderPresentationTreeItemSelected(item: ITdoTreeItem) {
    this.selectedPatientTreeNode = item as IoTreeNodeModel;
    this.getThumbnails(item as IoTreeNodeModel);
  }



  reloadImages() {
    this.getThumbnails(this.selectedPatientTreeNode);
  }

  getThumbnails(treeNode: IoTreeNodeModel = null) {
    // console.log('getThumbnails', treeNode);
    this.isImagesLoading = true;
    if (treeNode && treeNode.name === 'Categories') {
      treeNode = null;
    }

    const model = new GetDocumentThumbnailModel();
    model.patientId = this.globals.currentPatientId;
    model.toothNumberingId = this.globals.currentToothNumberingId;

    if (treeNode) {
      model.id = treeNode.id;
      model.type = treeNode.type;

      switch (model.type) {
        case IoTreeNodeTypeModel.Category:
          model.tagEnumId = treeNode.id;
          break;
        case IoTreeNodeTypeModel.Case:
          model.patientCaseId = treeNode.id;
          break;
        case IoTreeNodeTypeModel.Teeth:
          model.toothId = treeNode.id;
          break;
      }

      if (treeNode.parent) {
        model.type = treeNode.parent.type;
        switch (treeNode.parent.type) {
          case IoTreeNodeTypeModel.Category:
            model.tagEnumId = treeNode.parent.id;
            break;
          case IoTreeNodeTypeModel.Case:
            model.patientCaseId = treeNode.parent.id;
            break;
          case IoTreeNodeTypeModel.Teeth:
            model.toothId = treeNode.parent.id;
            break;
        }
      }

      if (treeNode.parent?.parent) {
        model.type = treeNode.parent.parent.type;
        switch (treeNode.parent.parent.type) {
          case IoTreeNodeTypeModel.Category:
            model.tagEnumId = treeNode.parent.parent.id;
            break;
          case IoTreeNodeTypeModel.Case:
            model.patientCaseId = treeNode.parent.parent.id;
            break;
          case IoTreeNodeTypeModel.Teeth:
            model.toothId = treeNode.parent.parent.id;
            break;
        }
      }
    } else {
      model.type = -1 as IoTreeNodeTypeModel;
    }
    this.updateImages(model);
  }

  updateImages(model: GetDocumentThumbnailModel) {
    this.fileManagerService.getDocumentThumbnails(model).subscribe(async (res) => {
      this.images = res;
      this.numImages = this.images.length;
      this.numSelectedImages = 0;
      this.selectedImages = [];
      this.thumbnailImages = [];

      this.isImagesLoading = false;
      this.mapThumbnails();
      this.cdr.detectChanges();

      const labelModel = new LabelRequestModel();
      labelModel.enumFormattedLabelID = FormattedLabelEnum.IOImageLabel;
      labelModel.objectIds = res.map(p => p.dataDocument.DocumentID);
      const tooltipModel = new LabelRequestModel();
      tooltipModel.enumFormattedLabelID = FormattedLabelEnum.IOImageTooltip;
      tooltipModel.objectIds = res.map(p => p.dataDocument.DocumentID);
      // get claim data
      if (labelModel.objectIds.length > 0) {
        const promises: any[] = [
          this.labelService.getOrganizerLabels(tooltipModel).toPromise(),
          this.labelService.getOrganizerLabels(labelModel).toPromise(),
        ];

        const results: any[] = await Promise.all(promises);
        this.tooltipsResponseModels = results[0];
        this.labelResponseModels = results[1];
        this.cdr.detectChanges();
      }
      //this.imageGrid.updateLabels(this.labelResponseModels, this.tooltipsResponseModels);      
    });
  }

  mapThumbnails() {
    this.thumbnailImages = this.images.map((o) => {
      const model = new DocumentDataImageModel();
      model.imageSource = this.fileService.getDocumentUrlFromDocument(o.dataDocument);
      model.model = Object.assign(o);
      return model;
    });
    this.isImagesLoading = false;
    if (this.imageGrid) {
      this.imageGrid.forceUpdate(this.thumbnailImages);
    }
  }

  imageReorder(event: ReorderEventData): void {
    moveItemInArray(this.images, event.sourceIndex, event.targetIndex);
  }

  // Tree template related
  isItemSelected(item: ITdoTreeItem): boolean {
    return item === this.selectedPatientTreeNode;
  }

  isItemHasChildren(item: ITdoTreeItem): boolean {
    return item.children.length > 0;
  }

  onItemDragEntered(event: CdkDragEnter<ITdoImageGridItem>): void {

  }

  onItemDragExited(event: CdkDragExit<ITdoImageGridItem>): void {

  }

  onItemDragDropped(event: CdkDragDrop<ITdoImageGridItem>): void {
    // console.log('teset');
  }

  onRightClickContextEvent(event: RightClickData): void {

  }

  openImageDetails(event: DocumentDataModel): void {

  }

  openCollageInNewWindow(): void {
    // console.log("openCollageInNewWindow called");
    // console.log("openCollageInNewWindow selectedImages: ", this.selectedImages);


    let items = this.selectedImages.map(p => p as DocumentInFolderDataModel);
    // console.log("openCollageInNewWindow items: ", items);

    items = items.filter(p => p.dataDocument.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.JPG || p.dataDocument.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.PNG);

    // console.log("openCollageInNewWindow items: ", items);
    const itemsData = items.map(p => p.dataDocument);

    // console.log("openCollageInNewWindow itemsData: ", itemsData);
    localStorage.setItem('open-in-collage', JSON.stringify(itemsData));


    this.uiService.openImagingCenterWindow(true);
  }

  onOpenImagingInNewWindowClick() {
    const mod = new OrganizerOpenInImagingModel();
    if (!this.selectedPatientTreeNode.isPatientTree) {
      mod.folderId = this.selectedPatientTreeNode.id;
    }
    localStorage.setItem('open-in-imaging', JSON.stringify(mod));
    this.openImagingInNewWindow();
  }

  openImagingInNewWindow(isReload = false): void {
    this.uiService.openImagingWindow(isReload);
    // console.log('in Organizer sending SignalrService.REFRESH_IMAGING');
    setTimeout(() => {
      this.signalrService.messageSingleUser(this.authService.currentUserValue.authdata.userid, SignalrService.REFRESH_IMAGING, { patientId: this.globals.currentPatientId });
    }, 2000);
  }

  openSlideshow(documents: DocumentDataModel[] = []) {
    let parentIds: string[] = [];

    if (documents.length === 0) {
      if (this.selectedImages.length > 0) {
        parentIds = this.selectedImages.map(p => p.dataDocument.ParentDocumentID);
      } else {
        parentIds = this.images.map(p => p.dataDocument.ParentDocumentID);
      }
    } else {
      parentIds.push(documents[0].ParentDocumentID);
    }

    const config = new MatDialogConfig();
    config.panelClass = 'standard-dialog';
    config.data = parentIds;
    config.maxWidth = '100dvw';
    config.maxHeight = '100dvh';
    config.width = '98%';
    config.height = '98%';
    this.dialog.open(TdoOrganizerSlideshowDialogComponent, config).afterClosed().subscribe((res) => {
      //
    });
  }

  onNewTabClick() {
    window.open('/landing/organizer');
  }

  onViewTypeSelected(event: TdoDropdownModel) {
    // console.log('onViewTypeSelected', event);
    // console.log('onViewTypeSelected labels: ', this.labelResponseModels);
    // console.log('onViewTypeSelected tooltips: ', this.tooltipsResponseModels);
    this.viewType = event.value;
    // console.log('onViewTypeSelected viewType: ', this.viewType);
    // console.log('onViewTypeSelected selectedImages: ', this.selectedImages);
    if (this.viewType === 'pane' && this.selectedImages.length > 0) {
      this.fileService.getTeeth(this.selectedImages).subscribe((res) => {
        if (res) {
          this.selectedImages.forEach(a => {
            res.forEach(b => {
              a.dataDocument.listOfTeeth = b.dataDocument.listOfTeeth;
            });
          });
        }
      });
      return this.selectedImages;
    }
    //else
    //this.imageGrid.updateLabels(this.labelResponseModels, this.tooltipsResponseModels);
  }

  onSortSelected(event: TdoDropdownModel) {
    this.sortType = event.value;
    switch (event.value) {
      case 'user_defined':
        this.images.sort((a, b) => {
          return a.DocumentOrder - b.DocumentOrder;
        });
        break;
      case 'date_created':
        this.images.sort((a, b) => {
          if (this.isAscending) {
            return moment(a.dataDocument.DocumentCreateDate).valueOf() - moment(b.dataDocument.DocumentCreateDate).valueOf();
          }
          else {
            return moment(b.dataDocument.DocumentCreateDate).valueOf() - moment(a.dataDocument.DocumentCreateDate).valueOf();
          }
        });
        break;
      case 'date_modified':
        this.images.sort((a, b) => {
          if (this.isAscending) {
            return moment(a.dataDocument.DocumentModifiedDate).valueOf() - moment(b.dataDocument.DocumentModifiedDate).valueOf();
          }
          else {
            return moment(b.dataDocument.DocumentModifiedDate).valueOf() - moment(a.dataDocument.DocumentModifiedDate).valueOf();
          }
        });
        break;
    }
    this.mapThumbnails();
  }

  onImageSizeSelected(event: TdoDropdownModel): void {
    this.thumbnailImageSize = event.value;
  }

  onAscendingToggle() {
    this.isAscending = !this.isAscending;
    this.images = this.images.reverse();
    this.numImages = this.images.length;
    this.mapThumbnails();
  }

  isFilterActive() {
    const isNoCriteria = !this.filterModel.isCompletedCases && !this.filterModel.isGentleWaveProcedure && !this.filterModel.isInTreatment
      && !this.filterModel.isNoDefinitiveEndoPerformed && !this.filterModel.isSuperRecall;
    if (this.filterModel.doctor || this.filterModel.referringDoctor || this.filterModel.range || this.filterModel.categoriesEnums.length > 0
      || !isNoCriteria) {
      return true;
    }
    return false;
  }

  onGridContextMenu(event: TdoImageGridContextModel) {
    this.openContext(event.event, this.imageContextTemplate, event, this.selectedPatientTreeNode);
  }

  onItemDoubleClick(event: ITdoImageGridItem) {
    // console.log('TDOOrganizerComponent onItemDoubleClick', event);
    const model = event.model as DocumentInFolderDataModel;
    const data: DocumentInFolderDataModel[] = [];
    this.fileService.getDocument(model.dataDocument.ParentDocumentID).subscribe((res) => {
      data.push(model);
      if (this.returnDocumentIDMode) {
        // pass document id back to caller
        const upDocs: string[] = [];
        upDocs.push(res.DocumentID);

        // close modal and pass back upDocs
        this.dialogRef.close(upDocs);
      }
      else if (this.isDocument3DVolume(model.dataDocument)) {
        // CBCT thumbnails/icons open the volume itself rather than the icon in Studio - same action as the
        // right-click "Open Volume" context menu item.
        this.open3DVolume(model.dataDocument);
      }
      else if (res.enumDocumentFileTypeID.toLocaleLowerCase() === DocumentFileTypeEnum.JPG.toLowerCase() || res.enumDocumentFileTypeID.toLocaleLowerCase() === DocumentFileTypeEnum.PNG.toLowerCase()) {
        // Open in Draw
        const openInImagingModel = new OrganizerOpenInImagingModel();
        if (!this.selectedPatientTreeNode.isPatientTree) {
          openInImagingModel.folderId = this.selectedPatientTreeNode.id;
        }
        openInImagingModel.documents = data.map(p => p.dataDocument);
        localStorage.setItem('open-in-imaging', JSON.stringify(openInImagingModel));
        if (this.isPickList) {
          this.signalrService.messageSingleUser(this.authService.currentUserValue.authdata.userid, SignalrService.REFRESH_IMAGING, { patientId: this.globals.currentPatientId });
          this.dialogRef.close();
        }
        else {
          this.openImagingInNewWindow();
        }
      } else {
        this.openSlideshow(data.map(p => p.dataDocument));
      }
    });
  }

  onGridItemsSelected(event: ITdoImageGridItem[]) {
    // console.log("onGridItemsSelected event: ", event);
    this.closeContext();
    this.selectedImages = event.map(p => p.model as DocumentInFolderDataModel);
    this.numSelectedImages = this.selectedImages.length;
    if (this.viewType === 'pane') {
      if (this.selectedImages.length > 0) {
        this.fileService.getTeeth(this.selectedImages).subscribe((res) => {
          if (res) {
            this.selectedImages.forEach(image => {
              const matchingImage = res.find(result => result.DocumentID === image.DocumentID);
              if (matchingImage) {
                image.dataDocument.listOfTeeth = matchingImage.dataDocument.listOfTeeth;
              }
            });
            this.cdr.detectChanges();
          }
        });
      }
      return this.selectedImages;
    }
    else {
      return this.selectedImages;
    }
  }

  // Context menu events
  onGridDeleteDocumentsClick(data: TdoImageGridContextModel) {
    let msg = '';
    let fileCount = data.selectedItems.length;
    if (!data.selectedItems.includes(data.contextItem)) {
      fileCount++;
    }
    if (data.selectedItems.length === 0) {
      msg = 'Are you sure you want to delete the selected file?';
    } else {
      msg = `Are you sure you want to delete the ${fileCount} selected files?`;
    }
    this.openConfirmDialog(msg, 'delete', data);
  }

  onGridOpenInImaging(data: TdoImageGridContextModel) {
    // console.log("onGridOpenInImaging");
    let items = data.selectedItems.concat().map(p => p.model as DocumentInFolderDataModel);
    if (!data.selectedItems.includes(data.contextItem)) {
      items.push(data.contextItem.model as DocumentInFolderDataModel);
    }

    items = items.concat().filter(p => p.dataDocument.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.JPG || p.dataDocument.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.PNG);


    const openInImagingModel = new OrganizerOpenInImagingModel();
    if (!this.selectedPatientTreeNode.isPatientTree) {
      openInImagingModel.folderId = this.selectedPatientTreeNode.id;
    }
    openInImagingModel.documents = items.map(p => p.dataDocument);
    localStorage.setItem('open-in-imaging', JSON.stringify(openInImagingModel));
    this.openImagingInNewWindow(true);
  }

  onGridOpenInImagingCenter(data: TdoImageGridContextModel) {
    // console.log("onGridOpenInImagingCenter data: ", data);
    let items = data.selectedItems.map(p => p.model as DocumentInFolderDataModel);
    // console.log("onGridOpenInImagingCenter items: ", items);
    if (!data.selectedItems.includes(data.contextItem)) {
      items.push(data.contextItem.model as DocumentInFolderDataModel);
    }
    items = items.filter(p => p.dataDocument.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.JPG || p.dataDocument.enumDocumentFileTypeID.toUpperCase() === DocumentFileTypeEnum.PNG);

    // console.log("onGridOpenInImagingCenter items: ", items);
    const itemsData = items.map(p => p.dataDocument);

    // console.log("onGridOpenInImagingCenter itemsData: ", itemsData);
    localStorage.setItem('open-in-collage', JSON.stringify(itemsData));
    this.openCollageInNewWindow();
  }

  onGridCategorizeDocumentsClick(data: TdoImageGridContextModel) {
    const items = this.getContextMenuDocuments(data);

    const dataObj = new TdoOrganizerCategorizeModel();
    dataObj.documentTagOptions = this.documentTagOptions;
    dataObj.documents = items.map(p => p.dataDocument);

    const config = new MatDialogConfig();
    config.panelClass = 'standard-dialog';
    config.data = dataObj;
    this.dialog.open(TdoOrganizerCategorizeDialogComponent, config).afterClosed().subscribe((res) => {
      if (res && res.length > 0) {
        const docIds = items.map(p => p.DocumentID);
        this.applyDocumentTags(docIds, res);
      }
    });
  }

  private getContextMenuDocuments(data: TdoImageGridContextModel): DocumentInFolderDataModel[] {
    const items = data.selectedItems.map(p => p.model as DocumentInFolderDataModel);
    if (!data.selectedItems.includes(data.contextItem)) {
      items.push(data.contextItem.model as DocumentInFolderDataModel);
    }
    return items;
  }

  private applyDocumentTags(docIds: string[], tagIds: string[]) {
    this.fileManagerService.addMultiDocumentsTags(docIds, tagIds).subscribe((response) => {
      this.fillPatientFolderTree();
      for (const docInFolder of this.images) {
        const newTagsForDoc = response.filter(p => p.DocumentID === docInFolder.DocumentID);
        docInFolder.dataDocument.dataDocumentTags = docInFolder.dataDocument.dataDocumentTags.concat(newTagsForDoc);
      }
      this.imageGrid.deselectAll();
      this.selectedImages = [];
      this.numSelectedImages = 0;
      if (tagIds.includes('0000001d-1000-0000-0000-000000000008') || tagIds.includes('0000001d-1000-0000-0000-000000000014')
        || tagIds.includes('0000001D-1000-0000-0000-000000000008') || tagIds.includes('0000001D-1000-0000-0000-000000000014')) {
        this.messagingService.sendComponentMessage(MessagingConstants.IO_TAGS_UPDATED, null);
      }

      if (tagIds.includes('0000001D-1000-0000-0000-000000000001') || tagIds.includes('0000001d-1000-0000-0000-000000000001')) {
        this.signalrService.messageAllUsers(SignalrService.UPDATE_PROFILE, { patientId: this.globals.currentPatientId });
      }
      this.mapThumbnails();

      // send message UPDATE_PATIENT_PICTURE to refresh Landing Page
      this.signalrService.messageSingleUser(this.authService.currentUserValue.authdata.userid, 'UPDATE_PATIENT_PICTURE', { patientId: this.globals.currentPatientId });
      this.notifyLandingWindowPatientPicture();
      // send message UPDATE_DOCUMENT to refresh pre-op post-op pictures in Landing Page
      this.signalrService.messageSingleUser(this.authService.currentUserValue.authdata.userid, 'UPDATE_DOCUMENT', { patientId: this.globals.currentPatientId });
    });
  }

  toggleFavoritesSubmenu(): void {
    this.isFavoritesSubmenuOpen = !this.isFavoritesSubmenuOpen;
    if (this.isFavoritesSubmenuOpen) {
      const favs = localStorage.getItem('document-tag-favorites');
      const favoriteIds: string[] = favs ? JSON.parse(favs) : [];
      this.favoriteCategorizeTags = (this.documentTagOptions || [])
        .filter(p => favoriteIds.includes(p.ValidValueItemId))
        .sort((a, b) => (a.ItemDisplayValue < b.ItemDisplayValue) ? -1 : (a.ItemDisplayValue > b.ItemDisplayValue) ? 1 : 0);
    }
    this.selectedFavoriteCategorizeTags = [];
  }

  isFavoriteCategorizeTagSelected(tag: EnumValidValueItemModel): boolean {
    return this.selectedFavoriteCategorizeTags.includes(tag);
  }

  onFavoriteCategorizeTagToggle(tag: EnumValidValueItemModel): void {
    const idx = this.selectedFavoriteCategorizeTags.indexOf(tag);
    if (idx > -1) {
      this.selectedFavoriteCategorizeTags.splice(idx, 1);
    } else {
      this.selectedFavoriteCategorizeTags.push(tag);
    }
  }

  onApplyFavoriteCategorizeTags(data: TdoImageGridContextModel): void {
    if (this.selectedFavoriteCategorizeTags.length === 0) {
      return;
    }
    const items = this.getContextMenuDocuments(data);
    const docIds = items.map(p => p.DocumentID);
    const tagIds = this.selectedFavoriteCategorizeTags.map(p => p.ValidValueItemId);
    this.applyDocumentTags(docIds, tagIds);
    this.closeContext();
  }

  async test() {
    await this.init();
  }

  onGridMoveDocumentsToTop(data: TdoImageGridContextModel) {
    this.gridContainer.nativeElement.scrollTo(0, 0);
    if (!data.selectedItems.includes(data.contextItem)) {
      data.selectedItems.push(data.contextItem);

    }
    const models = data.selectedItems.map(p => p.model as DocumentInFolderDataModel);
    const tmpArr: DocumentInFolderDataModel[] = [];
    for (const m of this.images) {
      if (!models.includes(m)) {
        tmpArr.push(m);
      }
    }
    tmpArr.unshift(...models);
    this.images = tmpArr;
    this.numImages = this.images.length;

    for (let i = 0; i < this.images.length - 1; i++) {
      this.images[i].DocumentOrder = i;
    }

    this.fileService.updateDocumentsOrder(this.images).subscribe(() => {

    });

    this.imageGrid.deselectAll();
    this.selectedImages = [];
    this.numSelectedImages = 0;
    this.mapThumbnails();

    // Move to top would be different depending on if ascending or descending.
    // save to backend - Since moving to top, all after would have to iterate up X amount, where X is how many items were moved.
  }

  async getFile(url: string) {
    const blob: any = await this.fileManagerService.downloadFileData(url).toPromise();
    blob.lastModifiedDate = new Date();
    blob.name = '';
    return blob as File;
  }

  async getFileFromDocument(doc: DocumentDataModel) {
    const blob: any = await this.fileManagerService.downloadFileData(
      this.fileManagerService.getDocumentUrlFromDocument(doc)
    ).toPromise();
    blob.lastModifiedDate = new Date();
    blob.name = doc.DocumentFileName;
    return blob as File;
  }

  async onCopyFilePathToClipboard(data: TdoImageGridContextModel) {
    if (!data.selectedItems.includes(data.contextItem)) {
      data.selectedItems.push(data.contextItem);
    }

    if (data.selectedItems.length > 0) {
      const docs = data.selectedItems.map(p => (p.model as DocumentInFolderDataModel).dataDocument) as DocumentDataModel[];
      const docsIds = docs.map(p => p.ParentDocumentID);

      const dls = await this.fileService.getDocuments(docsIds).toPromise();
      const files: File[] = [];
      for (const d of dls) {
        const file = await this.getFileFromDocument(d);
        files.push(file);
      }
      openFolderToSaveTo(files);
    }
  }

  onGridCutOrCopy(data: TdoImageGridContextModel, isCut = false) {
    if (!data.selectedItems.includes(data.contextItem)) {
      data.selectedItems.push(data.contextItem);
    }

    const documentIds = data.selectedItems.map(p => p.model.DocumentID);
    const toStore = new TdoClipboardBaseModel();
    toStore.parentId = this.selectedPatientTreeNode.id;
    toStore.type = TdoClipboardBaseModel.TYPE_DOCUMENT_DATA;
    if (isCut) {
      toStore.action = TdoClipboardBaseModel.ACTION_CUT;
    }
    toStore.copyData = documentIds;
    localStorage.setItem('tdo-clipboard', JSON.stringify(toStore));

  }

  async onGridPaste() {
    // console.log('Grid paste clicked');

    try {
      // Check if Clipboard API is available
      if (!navigator.clipboard) {
        console.warn('Clipboard API not available');
        this.snackbar.open('Clipboard API not supported in this browser', '', {
          duration: 3000,
          verticalPosition: 'top'
        });
        return;
      }

      // Read clipboard contents
      const clipboardItems = await navigator.clipboard.read();

      // Look for image data in clipboard
      for (const clipboardItem of clipboardItems) {
        for (const type of clipboardItem.types) {
          if (type.startsWith('image/')) {
            // console.log('Found image in clipboard:', type);

            // Get the image blob
            const blob = await clipboardItem.getType(type);

            // Convert blob to File object
            const file = new File([blob], 'pasted-image.png', { type: type });

            // Upload the pasted image
            this.uploadPastedImage(file);
            return;
          }
        }
      }

      // No image found in clipboard
      this.snackbar.open('No image found in clipboard', '', {
        duration: 3000,
        verticalPosition: 'top'
      });

    } catch (error) {
      console.error('Error reading clipboard:', error);
      this.snackbar.open('Error reading clipboard. Please ensure clipboard access is granted.', '', {
        duration: 5000,
        verticalPosition: 'top'
      });
    }
  }

  private uploadPastedImage(file: File) {
    try {
      this.isImagesLoading = true;

      // Create DocumentUploadModel for the pasted image
      const uploadModel = new DocumentUploadModel();
      uploadModel.blob = file;
      uploadModel.docClassId = DocumentClassEnum.Original;
      uploadModel.docTypeId = DocumentTypeEnum.Scan;
      uploadModel.hasAnnotation = false;
      uploadModel.docTagIds = [];

      // Set patient or folder context
      if (this.selectedPatientTreeNode.isPatientTree) {
        uploadModel.patientId = this.globals.currentPatientId;
        uploadModel.patientCaseId = this.globals.currentPatientCaseId;
      } else {
        uploadModel.folderId = this.selectedPatientTreeNode.id;
      }

      uploadModel.createDate = this.datePipe.transform(new Date(), 'MMM dd, yyyy H:mm:ss');

      // Upload the document
      this.fileManagerService.uploadDocuments([uploadModel]).subscribe((response) => {
        this.getThumbnails(this.selectedPatientTreeNode);
        this.fillPatientFolderTree();

        this.snackbar.open('Image pasted successfully', '', {
          duration: 3000,
          verticalPosition: 'top'
        });

        this.isImagesLoading = false;
      }, error => {
        console.error('TDO Organizer paste image error:', error);
        this.isImagesLoading = false;
        this.snackbar.open('Error uploading pasted image', '', {
          duration: 5000,
          verticalPosition: 'top'
        });
      });

    } catch (error) {
      console.error('Error uploading pasted image:', error);
      this.isImagesLoading = false;
      this.snackbar.open('Error uploading pasted image', '', {
        duration: 5000,
        verticalPosition: 'top'
      });
    }
  }

  // Manipulate documents
  deleteDocuments(data: TdoImageGridContextModel) {
    // this.isImagesLoading = true;
    const model = data as TdoImageGridContextModel;
    if (!model.selectedItems.includes(model.contextItem)) {
      model.selectedItems.push(model.contextItem);
    }
    const documentIds = model.selectedItems.map(p => (p.model as DocumentDataImageModel).DocumentID);

    const docsToRemoveModel = new DocumentsPerFolderModel();
    docsToRemoveModel.documentIds = documentIds;
    docsToRemoveModel.isPatientTree = this.selectedPatientTreeNode.isPatientTree;
    docsToRemoveModel.patientId = this.globals.currentPatientId;
    docsToRemoveModel.folderId = this.selectedPatientTreeNode.id;
    this.fileManagerService.removeDocumentsFromFolder(docsToRemoveModel).subscribe((res) => {
      this.images = this.images.filter(p => !documentIds.includes(p.DocumentID));
      this.numImages = this.images.length;
      this.selectedImages = [];
      this.numSelectedImages = 0;
      // send message UPDATE_PATIENT_PICTURE to refresh Landing Page
      this.signalrService.messageSingleUser(this.authService.currentUserValue.authdata.userid, 'UPDATE_PATIENT_PICTURE', { patientId: this.globals.currentPatientId });
      this.notifyLandingWindowPatientPicture();
      // send message UPDATE_DOCUMENT to refresh pre-op post-op pictures in Landing Page
      this.signalrService.messageSingleUser(this.authService.currentUserValue.authdata.userid, 'UPDATE_DOCUMENT', { patientId: this.globals.currentPatientId });


      if (this.imageGrid) {
        this.imageGrid.deselectAll();
      }
      this.isImagesLoading = false;
      let filesStr = 'file';
      if (documentIds.length > 1) {
        filesStr = 'files';
      }
      this.openSnackbar(`Successfully deleted ${documentIds.length} ${filesStr}`);
      this.fillPatientFolderTree();
      this.mapThumbnails();
    });
  }

  private notifyLandingWindowPatientPicture(): void {
    try {
      const payload = JSON.stringify({ patientId: this.globals.currentPatientId, t: Date.now() });
      localStorage.setItem(MessagingConstants.LOCAL_STORAGE_PATIENT_PICTURE_REFRESH, payload);
      // Browsers suppress real storage events for writes made in the same window, so dispatch
      // a synthetic one so home.component's onPatientPictureStorage handler fires immediately.
      window.dispatchEvent(new StorageEvent('storage', {
        key: MessagingConstants.LOCAL_STORAGE_PATIENT_PICTURE_REFRESH,
        newValue: payload,
        storageArea: localStorage
      }));
    } catch { /* private mode / quota */ }
  }

  openSnackbar(msg: string, duration = 5000) {
    this.snackbar.open(msg, '', { duration });
  }

  // Dialog
  openConfirmDialog(msg: string, type: string, data: any) {
    this.dialogService.openConfirmDialog(msg).subscribe((result) => {
      if (result === true) {
        switch (type) {
          case 'delete':
            this.deleteDocuments(data);
            break;
        }
      } else {
        //
      }
    });
  }

  // Context boilerplate
  openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, data1: any = null, closeOnItemClick = true): void {
    this.closeContext();
    x = x + 100;
    y = y - 10;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data, data1 }));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
    this.isFavoritesSubmenuOpen = false;
    this.selectedFavoriteCategorizeTags = [];
  }


  // Library ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  private initLibraryTree(folders: DocumentFolderDataModel[]): void {
    const treeNode = new IoTreeNodeModel();
    const rootNodeData = folders[0];
    treeNode.id = rootNodeData.DocumnetFolderId;
    treeNode.name = rootNodeData.FolderName;
    treeNode.type = IoTreeNodeTypeModel.Library;
    treeNode.isExpanded = true;
    this.libraryTreeData.push(treeNode);

    const trashNode = new IoTreeNodeModel();
    trashNode.id = 'libraryTrash';
    trashNode.name = 'Trash';
    trashNode.type = IoTreeNodeTypeModel.Trash_Library;
    trashNode.isExpanded = false;
    trashNode.matIconOverride = 'delete';
    treeNode.children.push(trashNode);

    const nonRootFolders = folders.filter(p => p.DocumentFolderParentId !== null);

    for (const folder of nonRootFolders) {
      const childNode = new IoTreeNodeModel();
      childNode.id = folder.DocumnetFolderId;
      childNode.name = folder.FolderName;
      childNode.type = IoTreeNodeTypeModel.Library;
      childNode.isExpanded = false;

      if (folder.DocumentFolderParentId === treeNode.id) {
        treeNode.children.push(childNode);
      } else {
        const parent = this.sortFoldersIntoFolders(treeNode, folder);
        parent.children.push(childNode);
      }
    }
    this.cdr.detectChanges();
  }

  // Library ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  private initLectureTree(folders: DocumentFolderDataModel[]): void {
    const treeNode = new IoTreeNodeModel();
    const rootNodeData = folders[0];
    treeNode.id = rootNodeData.DocumnetFolderId;
    treeNode.name = rootNodeData.FolderName;
    treeNode.type = IoTreeNodeTypeModel.Lecture;
    treeNode.isExpanded = true;
    this.lectureTreeData.push(treeNode);

    const trashNode = new IoTreeNodeModel();
    trashNode.id = 'lectureTrash';
    trashNode.name = 'Trash';
    trashNode.type = IoTreeNodeTypeModel.Trash_Lecture;
    trashNode.isExpanded = false;
    trashNode.matIconOverride = 'delete';
    treeNode.children.push(trashNode);

    const nonRootFolders = folders.filter(p => p.DocumentFolderParentId !== null);

    for (const folder of nonRootFolders) {
      const childNode = new IoTreeNodeModel();
      childNode.id = folder.DocumnetFolderId;
      childNode.name = folder.FolderName;
      childNode.type = IoTreeNodeTypeModel.Lecture;
      childNode.isExpanded = false;

      if (folder.DocumentFolderParentId === treeNode.id) {
        treeNode.children.push(childNode);
      } else {
        const parent = this.sortFoldersIntoFolders(treeNode, folder);
        parent.children.push(childNode);
      }
    }
  }

  //// Folder Presentation
  private initFolderPresentationTree(folders: DocumentFolderDataModel[]): void {
    const treeNode = new IoTreeNodeModel();
    const rootNodeData = folders[0];
    treeNode.id = rootNodeData.DocumnetFolderId;
    treeNode.name = rootNodeData.FolderName;
    treeNode.type = IoTreeNodeTypeModel.Lecture;
    treeNode.isExpanded = true;
    this.folderPresentationTreeData.push(treeNode);

    const nonRootFolders = folders.filter(p => p.DocumentFolderParentId !== null && p.DocumnetFolderId !== rootNodeData.DocumnetFolderId &&
      p.DocumentFolderParentId.toUpperCase() !== DOC_FOLDER_ROOT_PATIENT &&
      p.DocumentFolderParentId.toUpperCase() !== DOC_FOLDER_ROOT_LECTURE &&
      p.DocumentFolderParentId.toUpperCase() !== DOC_FOLDER_ROOT_LIBRARY);

    for (const folder of nonRootFolders) {
      const childNode = new IoTreeNodeModel();
      childNode.id = folder.DocumnetFolderId;
      childNode.name = folder.FolderName;
      childNode.type = IoTreeNodeTypeModel.Lecture;
      childNode.isExpanded = false;

      if (folder.DocumentFolderParentId === treeNode.id) {
        treeNode.children.push(childNode);
      } else {
        const parent = this.sortFoldersIntoFolders(treeNode, folder);
        parent.children.push(childNode);
      }
    }
  }

  sortFoldersIntoFolders(treeNode: IoTreeNodeModel, folder: DocumentFolderDataModel): IoTreeNodeModel {
    const node = treeNode.children.find(p => p.id === folder.DocumentFolderParentId);
    if (node) {
      return node;
    } else {
      for (const innerNode of treeNode.children) {
        const tmp = this.sortFoldersIntoFolders(innerNode, folder);
        if (tmp) {
          return tmp;
        }
      }
    }
  }

  removeFolderFromTree(parent: IoTreeNodeModel, item: IoTreeNodeModel): boolean {
    const isInNodeChildren = parent.children.findIndex(p => p === item);
    if (isInNodeChildren > -1) {
      parent.children.splice(isInNodeChildren, 1);
      return true;
    } else {
      for (const mod of parent.children) {
        if (this.removeFolderFromTree(mod, item)) {
          return true;
        }
      }
    }
  }

  FindFolderFromTree(parent: IoTreeNodeModel, folderId: string): boolean {
    let isFound = false;
    const isInNodeChildren = parent.children.findIndex(p => p.id === folderId);
    if (isInNodeChildren > -1) {
      this.selectedPatientTreeNode = parent.children[isInNodeChildren];
      isFound = true;
      return true;
    } else {
      for (const mod of parent.children) {
        if (this.FindFolderFromTree(mod, folderId)) {
          isFound = true;
          return true;
        }
      }
    }
    return isFound;
  }

  onLibraryTreeContext(event: MouseEvent, item: IoTreeNodeModel) {
    this.openContext(event, this.lectureContextTemplate, item);
  }

  onPatientTreeContext(event: MouseEvent, item: IoTreeNodeModel) {
    this.openContext(event, this.patientContextTemplate, item);
  }

  onFolderBackgroundContext(event: MouseEvent, item: IoTreeNodeModel) {
    this.openContext(event, this.folderBackgroundContextMenu, item);
  }

  // Lecture Library Context
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  addDocumentFolder(data: IoTreeNodeModel) {
    const config = new MatDialogConfig();
    config.panelClass = 'standard-dialog';
    config.data = { isNew: true };
    this.dialog.open(TdoOrganizerRenameDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        const mod = new DocumentFolderDataModel();
        mod.FolderName = res;
        mod.DocumentFolderParentId = data.id;
        switch (data.type) {
          case IoTreeNodeTypeModel.Library:
            mod.enumDocumnetFolderTypeID = DocumentFolderTypeEnum.Library;
            break;
          case IoTreeNodeTypeModel.Lecture:
            mod.enumDocumnetFolderTypeID = DocumentFolderTypeEnum.Lecture;
            break;
        }
        this.fileManagerService.addDocumentFolder(mod).subscribe((response) => {
          data.isExpanded = true;
          data.children.push(this.convertFolderModelToTreeModel(response));
        });
      }
    });
  }

  deleteDocumentFolder(data: IoTreeNodeModel) {
    this.fileManagerService.deleteDocumentFolder(data.id).subscribe((res) => {
      switch (data.type) {
        case IoTreeNodeTypeModel.Lecture:
          this.removeFolderFromTree(this.lectureTreeData[0], data);
          if (this.selectedPatientTreeNode === data) {
            this.selectedPatientTreeNode = this.lectureTreeData[0];
          }
          break;
        case IoTreeNodeTypeModel.Library:
          this.removeFolderFromTree(this.libraryTreeData[0], data);
          if (this.selectedPatientTreeNode === data) {
            this.selectedPatientTreeNode = this.libraryTreeData[0];
          }

          break;
      }
    });
  }

  renameDocumentFolder(data: IoTreeNodeModel) {
    const config = new MatDialogConfig();
    config.panelClass = 'standard-dialog';
    config.data = { name: data.name };

    const mod = new DocumentUpdateFolderModel();
    mod.DocumentFolderID = data.id;

    this.dialog.open(TdoOrganizerRenameDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        mod.DocumentName = res;
        this.fileManagerService.updateDocumentFolder(mod).subscribe((response) => {
          data.name = res;
        });
      }
    });
  }

  convertFolderModelToTreeModel(folder: DocumentFolderDataModel): IoTreeNodeModel {
    const treeNode = new IoTreeNodeModel();
    treeNode.id = folder.DocumnetFolderId;
    treeNode.name = folder.FolderName;

    switch (folder.enumDocumnetFolderTypeID.toUpperCase()) {
      case DocumentFolderTypeEnum.Library:
        treeNode.type = IoTreeNodeTypeModel.Library;
        break;
      case DocumentFolderTypeEnum.Lecture:
        treeNode.type = IoTreeNodeTypeModel.Lecture;
        break;
    }

    return treeNode;
  }

  onLibraryLecturePaste(node: IoTreeNodeModel) {
    const clipboardData = localStorage.getItem('tdo-clipboard');
    const clipboardModel: TdoClipboardBaseModel = JSON.parse(clipboardData);

    if (clipboardModel.type !== TdoClipboardBaseModel.TYPE_DOCUMENT_DATA) {
      return;
    }

    if (clipboardModel.parentId !== node.id) {
      const ids = clipboardModel.copyData as string[];
      const addModel = new DocumentsPerFolderModel();
      addModel.documentIds = ids;
      addModel.folderId = node.id;
      if (clipboardModel.action === TdoClipboardBaseModel.ACTION_CUT) {
        addModel.cutFromFolderId = clipboardModel.parentId;
      }
      this.fileManagerService.addDocumentsToFolder(addModel).subscribe((res) => {
        this.selectedPatientTreeNode = node;
        this.getThumbnails(this.selectedPatientTreeNode);
        // Should we select the paste folder to show its contents?
      });
    }
  }

  onPatientPaste(node: IoTreeNodeModel) {
    const clipboardData = localStorage.getItem('tdo-clipboard');
    const clipboardModel: TdoClipboardBaseModel = JSON.parse(clipboardData);

    if (clipboardModel.type !== TdoClipboardBaseModel.TYPE_DOCUMENT_DATA) {
      return;
    }

    const patientId = this.globals.currentPatientId;

    if (clipboardModel.parentId !== node.id) {
      const ids = clipboardModel.copyData as string[];
      const addModel = new DocumentsPerFolderModel();
      addModel.documentIds = ids;
      // addModel.folderId = node.id;
      addModel.patientId = patientId;

      if (clipboardModel.action === TdoClipboardBaseModel.ACTION_CUT) {
        addModel.cutFromFolderId = clipboardModel.parentId;
      }

      this.fileManagerService.addDocumentsToFolder(addModel).subscribe((addResponse) => {
        const items = this.selectedImages;
        this.selectedPatientTreeNode = node;
        this.getThumbnails(this.selectedPatientTreeNode);
        // Should we select the paste folder to show its contents?

        const dataObj = new TdoOrganizerCategorizeModel();
        dataObj.documentTagOptions = this.documentTagOptions;
        dataObj.documents = items.map(p => p.dataDocument);

        const config = new MatDialogConfig();
        config.panelClass = 'standard-dialog';
        config.data = dataObj;
        this.dialog.open(TdoOrganizerCategorizeDialogComponent, config).afterClosed().subscribe((res) => {
          if (res && res.length > 0) {
            const docIds = items.map(p => p.DocumentID);
            this.fileManagerService.addMultiDocumentsTags(docIds, res).subscribe((response) => {
              // Replace the old with the new
              for (const docInFolder of this.images) {
                const newTagsForDoc = response.filter(p => p.DocumentID === docInFolder.DocumentID);
                docInFolder.dataDocument.dataDocumentTags = docInFolder.dataDocument.dataDocumentTags.concat(newTagsForDoc);
              }
              this.selectedImages = [];
              this.numSelectedImages = 0;
              this.imageGrid.deselectAll();
              this.mapThumbnails();

              // TODO: Figure out how to make the list of categories update after
              // this.test();
            });
          }
        });
      });
    }
  }

  onPatientItemDroppedInTree(event: TdoTreeDropItem) {
    const models = event.data.item.data as DocumentInFolderDataModel[];
    const ids = models.map(p => p['model'].dataDocument.DocumentID);
    if (event.data.container.id.toLowerCase().includes('0000001d-1000')) {
      this.fileManagerService.addMultiDocumentsTags(ids, [event.data.container.id]).subscribe((res) => {
        const tag = this.staticDataService.validValueItems.find(p => p.ValidValueItemId.toLowerCase() === event.data.container.id.toLowerCase());
        if (tag) {
          this.snackbar.open(ids.length + ' items tagged as ' + tag.ItemDisplayValue, '', { verticalPosition: 'bottom', duration: 5000 });
        }
      });
    }
  }

  onItemDroppedInTree(event: TdoTreeDropItem) {
    const models = event.data.item.data as DocumentInFolderDataModel[];
    const ids = models.map(p => p['model'].dataDocument.DocumentID);
    const addModel = new DocumentsPerFolderModel();
    addModel.documentIds = ids;
    addModel.folderId = event.data.container.id;
    this.fileManagerService.addDocumentsToFolder(addModel).subscribe((res) => {
      // Should we select the drop folder to show its contents?
      this.snackbar.open(ids.length + ' items copied to folder', '', { verticalPosition: 'bottom', duration: 5000 });
    });
  }

  isNotRootNode(data: IoTreeNodeModel) {
    return data.id !== 'f0000002-0000-0000-0000-000000000001' && data.id !== 'f0000003-0000-0000-0000-000000000001' && data.id !== 'F0000001-0000-0000-0000-000000000001';
  }

  // This is the wrong data type being sent in and will never eval correctly.
  isPatientTreeOrChild(data: IoTreeNodeModel) {
    return this.selectedPatientTreeNode.isPatientTree;
  }

  is3DVolume() {
    return this.selectedImages.length === 1 && this.isDocument3DVolume(this.selectedImages[0].dataDocument);
  }

  private isDocument3DVolume(dataDocument: DocumentDataModel): boolean {
    const enumDocumentTypeCSCBCT = '0000001C-1000-0000-0000-000000000013';
    const enumDocumentTypeScreenShot = '0000001C-1000-0000-0000-000000000002';
    const typeId = dataDocument?.enumDocumentTypeID?.toUpperCase();
    return typeId === enumDocumentTypeCSCBCT.toUpperCase() || typeId === enumDocumentTypeScreenShot.toUpperCase();
  }
  onGridAreaClick() {
    this.imageGrid.deselectAll();
    this.selectedImages = [];
    this.numSelectedImages = 0;
  }

  fileSelected(files: FileList) {
    if (!files || files.length === 0) {
      this.isImagesLoading = false;
      return;
    }
    this.isImagesLoading = true;
    const models: DocumentUploadModel[] = [];
    const fz = Array.from(files);

    for (const file of fz) {
      const fileModel = file;
      const uploadModel = new DocumentUploadModel();
      uploadModel.blob = file;
      uploadModel.docClassId = DocumentClassEnum.Original;
      uploadModel.docTypeId = DocumentTypeEnum.Scan;
      uploadModel.hasAnnotation = false;
      uploadModel.docTagIds = [];
      if (this.selectedPatientTreeNode.isPatientTree) {
        uploadModel.patientId = this.globals.currentPatientId;
        uploadModel.patientCaseId = this.globals.currentPatientCaseId;
      } else {
        uploadModel.folderId = this.selectedPatientTreeNode.id;
      }
      uploadModel.createDate = this.datePipe.transform(new Date(file.lastModified), 'MMM dd, yyyy H:mm:ss');

      models.push(uploadModel);
      if (models.length === files.length) {
        this.fileManagerService.uploadDocuments(models).subscribe((response) => {
          this.getThumbnails(this.selectedPatientTreeNode);
          this.fillPatientFolderTree();
          // this.initializePatientFolderTree();

          if (this.returnDocumentIDMode) {
            const upDocs: string[] = [];
            response.documents.forEach(upDoc => {
              upDocs.push(upDoc.DocumentID);
            });

            // close modal and pass back upDocs
            this.dialogRef.close(upDocs);
          }
        }, error => {
          console.error('TDO Organizer uploadDocuments error:', error);
          this.isImagesLoading = false;
          this.uiService.displayMessage("Error", "Error uploading file.");
        });
      }
    }
  }

  onGridBackgroundContextMenu(event: MouseEvent) {
    this.openContext(event, this.folderBackgroundContextMenu, null);
  }

  onEmptyAreaContextMenu(event: MouseEvent) {
    // console.log('onEmptyAreaContextMenu called', event);
    const target = event.target as HTMLElement;
    // console.log('Target element:', target);
    // console.log('Target classes:', target.className);
    // console.log('Target tag name:', target.tagName);

    // For debugging - always show the context menu
    // console.log('Showing empty area context menu (debug mode)');
    event.preventDefault();
    event.stopPropagation();
    this.openContext(event, this.emptyAreaContextMenu, null);
  }

  onEmptyAreaPaste() {
    // Use the same paste functionality as the grid
    this.onGridPaste();
  }

  onFilesDraggedIntoImageGrid(event: FileList) {
    this.fileSelected(event);
  }

  onRestoreDeletedItems(data: TdoImageGridContextModel, restoreMode = 'standard') {
    if (!data.selectedItems.includes(data.contextItem)) {
      data.selectedItems.push(data.contextItem);
    }

    const restoreModel = new DocumentRestoreModel();
    restoreModel.patientId = this.globals.currentPatientId;
    const docs = data.selectedItems.map(p => p.model);
    restoreModel.documentIds = docs.map(p => p.DocumentID);

    switch (this.selectedPatientTreeNode.type) {
      case IoTreeNodeTypeModel.Trash_Patient:
        if (this.selectedPatientTreeNode.isPatientTree) {
          restoreModel.type = IoTreeNodeTypeModel.Default;
        } else {

        }
        this.fileService.restoreDeletedItems(restoreModel).subscribe(() => {
          this.getThumbnails(this.selectedPatientTreeNode);
          // send message UPDATE_PATIENT_PICTURE to refresh patient picture in Landing Page
          this.signalrService.messageSingleUser(this.authService.currentUserValue.authdata.userid, 'UPDATE_PATIENT_PICTURE', { patientId: this.globals.currentPatientId });
          this.notifyLandingWindowPatientPicture();
          // send message UPDATE_DOCUMENT to refresh pre-op post-op pictures in Landing Page
          this.signalrService.messageSingleUser(this.authService.currentUserValue.authdata.userid, 'UPDATE_DOCUMENT', { patientId: this.globals.currentPatientId });
        });
        break;
      case IoTreeNodeTypeModel.Trash_Library:
      case IoTreeNodeTypeModel.Trash_Lecture:
        restoreModel.type = IoTreeNodeTypeModel.Library;
        restoreModel.mode = restoreMode;
        if (restoreMode === 'standard') {
          for (const item of data.selectedItems) {
            const docInFolder = item.model as DocumentInFolderDataModel;
            const dif = new DocumentRestoreFolderModel();
            dif.documentFolderId = docInFolder.DocumnetFolderId;
            dif.documentId = docInFolder.dataDocument.DocumentID;
            restoreModel.documentInFolders.push(dif);
          }
          this.fileService.restoreDeletedItems(restoreModel).subscribe(() => {
            this.getThumbnails(this.selectedPatientTreeNode);
          });
        } else {
          const config = new MatDialogConfig();
          config.panelClass = 'dialog';
          this.dialog.open(TdoOrganizerRestoreDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {
              const ret = res as IoTreeNodeModel;
              restoreModel.documentFolderId = ret.id;
              restoreModel.type = res.type;
              this.fileService.restoreDeletedItems(restoreModel).subscribe(() => {
                this.getThumbnails(this.selectedPatientTreeNode);
              });
            }
          });
        }
        break;
    }
  }

  isTrashFolder(treeItem: IoTreeNodeModel) {
    return treeItem.type === IoTreeNodeTypeModel.Trash_Patient || treeItem.type === IoTreeNodeTypeModel.Trash_Lecture || treeItem.type === IoTreeNodeTypeModel.Trash_Library;
  }

  onItemsSorted(event: ITdoImageGridItem[]) {
    if (this.isTrashFolder(this.selectedPatientTreeNode)) {
      return;
    }

    const thumbs = event.map(p => p.model as DocumentInFolderDataModel);
    for (let i = 0; i < thumbs.length; i++) {
      thumbs[i].DocumentOrder = i;
    }

    this.fileService.updateDocumentsOrder(thumbs).subscribe(() => {

    });
  }

  onDuplicateDocument(data: TdoImageGridContextModel) {
    const enumDocumentclassStdHDBurnedIn = '00000075-1000-0000-0000-000000000006';
    const enumDocumentclass4kBurnedIn = '00000075-1000-0000-0000-000000000007';
    const enumDocumentclassStdBurnedIn = '00000075-1000-0000-0000-000000000008';
    if (!data.selectedItems.includes(data.contextItem)) {
      data.selectedItems.push(data.contextItem);
    }

    const docInFolder = data.selectedItems[0].model as DocumentInFolderDataModel;

    const parentDocIds = data.selectedItems.map(p => (p.model as DocumentInFolderDataModel).dataDocument.ParentDocumentID);

    this.fileManagerService.getDocuments(parentDocIds).subscribe((pres) => {
      const docs = pres;

      for (const doc of docs) {
        this.fileManagerService.downloadFileData(this.fileManagerService.getDocumentUrlFromDocument(doc)).subscribe((blob) => {
          const child = data.selectedItems.find(p => (p.model as DocumentInFolderDataModel).dataDocument.ParentDocumentID === doc.DocumentID);
          if (child) {
            const childDoc = (child.model as DocumentInFolderDataModel).dataDocument;
            const url = this.fileManagerService.getDocumentUrlFromDocument(childDoc);
            // console.log('Thumby: ' + url);
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.onload = (evt) => {
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d');
              canvas.width = image.width;
              canvas.height = image.height;
              context.drawImage(image, 0, 0, image.width, image.height);
              const f = this.fileHelperService.getImageThumbnailFromCanvas(canvas);

              const uploadModel = new DocumentUploadModel();
              uploadModel.duplicateDocId = docInFolder.dataDocument.DocumentID;
              uploadModel.blobThumbnail = this.fileHelperService.base64ToBlob(canvas.toDataURL(FileHelperService.MIME_JPG), FileHelperService.MIME_JPG);
              uploadModel.blob = blob;
              uploadModel.docTagIds = doc.dataDocumentTags.map(p => p.enumDocumentTagID);
              uploadModel.docTypeId = doc.enumDocumentTypeID;
              uploadModel.docFileTypeId = doc.enumDocumentFileTypeID;
              uploadModel.docClassId = '00000075-1000-0000-0000-000000000001';
              uploadModel.patientId = doc.PatientId;
              uploadModel.patientCaseId = doc.PatientCaseId;
              uploadModel.caseWorkItemId = doc.CaseWorkItemId;
              uploadModel.hasAnnotation = true;
              uploadModel.documentOrder = docInFolder.DocumentOrder;
              if (uploadModel.documentOrder < 0) {
                uploadModel.documentOrder = 0;
              }
              // check to see if the document is a burned-in image. If it is we need to establish the
              // parentDocId, set the docClassId to enumDocumentclassStdBurnedIn and download the annotation file
              if (doc.enumDocumentClassID === enumDocumentclassStdBurnedIn || doc.enumDocumentClassID === enumDocumentclass4kBurnedIn ||
                doc.enumDocumentClassID === enumDocumentclassStdHDBurnedIn) {
                uploadModel.parentDocId = doc.ParentDocumentID;
                uploadModel.docClassId = enumDocumentclassStdBurnedIn;
                this.fileManagerService.getDocumentAnnotation(doc.PhysicalFileName, doc.PatientId).subscribe((resAnnFile) => {
                  const urlAnn = this.fileManagerService.getDocumentUrlFromDocument(resAnnFile);
                  // console.log('in Organizer urlAnn ' + urlAnn);
                  if (urlAnn) {
                    // console.log('inside if urlAnn ');
                    this.fileManagerService.downloadFileData(urlAnn).subscribe((xmlBlob) => {
                      xmlBlob.text().then(annotationXmlData => {
                        uploadModel.blobXml = new Blob([annotationXmlData], { type: 'text/xml' });;
                        if (!this.selectedPatientTreeNode.isPatientTree) {
                          uploadModel.folderId = this.selectedPatientTreeNode.id;
                        }
                        this.fileManagerService.uploadDocuments([uploadModel]).subscribe((response) => {
                          this.imageGrid.deselectAll();
                          this.selectedImages = [];
                          this.numSelectedImages = 0;
                          this.getThumbnails(this.selectedPatientTreeNode);
                        }, (error => {
                          //
                        }));
                      });
                    });
                  }
                });
              }
              else {
                if (!this.selectedPatientTreeNode.isPatientTree) {
                  uploadModel.folderId = this.selectedPatientTreeNode.id;
                }

                this.imageGrid.forceResort();

                this.fileManagerService.uploadDocuments([uploadModel]).subscribe((response) => {
                  this.imageGrid.deselectAll();
                  this.selectedImages = [];
                  this.numSelectedImages = 0;
                  this.getThumbnails(this.selectedPatientTreeNode);
                }, error => this.isImagesLoading = false);
              }
            };
            this.fileManagerService.getAuthenticatedObjectUrl(url).subscribe((objectUrl) => {
              image.src = objectUrl;
            });
          }
        });
      }
    });
  }

  getDate(xauditCreatedOn: Date) {
    const d = new Date(xauditCreatedOn);
    return ConversionUtilities.convertUTCDateToLocalDateFromString(d.toLocaleString());
  }

  getCategories(dataDocumentTags: DocumentTagDataModel[]) {
    let str = '';
    for (const tag of dataDocumentTags) {
      if (str.length === 0) {
        str += tag.enumDocumentTag.ItemDisplayValue;
      } else {
        str += ', ' + tag.enumDocumentTag.ItemDisplayValue;
      }
    }
    return str;
  }

  onGridChangeCaseOrToothClick(data: TdoImageGridContextModel) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = data.contextItem.model as DocumentInFolderDataModel;
    this.dialog.open(TdoOrganizerCaseToothDialogComponent, config).afterClosed().subscribe((res) => {
      if (res) {
        this.getThumbnails(this.selectedPatientTreeNode);
        this.fillPatientFolderTree();
      }
    });
  }

  isMultiSelect(data: any) {
    const items = data.selectedItems.map(p => p.model as DocumentInFolderDataModel);
    if (!data.selectedItems.includes(data.contextItem)) {
      items.push(data.contextItem.model as DocumentInFolderDataModel);
    }

    return items.length > 1;
  }

  onOpen3DVolume() {
    this.open3DVolume(this.selectedImages[0].dataDocument);
  }

  private open3DVolume(dataDocument: DocumentDataModel) {
    this.drawService.isServiceBrokerRunning(() => {
      const intervalSubscription = setInterval(_ => {
        if (this.drawService.isSBRunning === true) {
          clearInterval(intervalSubscription);
          this.drawService.sendSBOpen3DVolume(dataDocument, () => {
          });
        } else {
          clearInterval(intervalSubscription);
          console.log('Service Broker is not running.');
          return;
        }
      }, 100);
    });
  }

  async onPrint(data: TdoImageGridContextModel) {
    let parentIds: string[] = [];
    parentIds = this.selectedImages.map(p => p.dataDocument.ParentDocumentID);
    this.printService.executePrint(parentIds);
  }

  ngOnDestroy(): void {
    if (this.refreshDebounceTimer !== null) {
      clearTimeout(this.refreshDebounceTimer);
    }
    window.removeEventListener('storage', this.onCrossWindowStorageRefresh);
    this._colorWorker?.terminate();
    this._effectsWorker?.terminate();
    for (const sub of this.subscriptions) {
      if (sub)
        sub.unsubscribe();
    }
    this.sub !== undefined && this.sub.unsubscribe();
  }

}
